import { render } from "./PortfolioBody.vue?vue&type=template&id=6aabf07b"
import script from "./PortfolioBody.vue?vue&type=script&lang=js"
export * from "./PortfolioBody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__